import { createSelector } from 'reselect';

const selectTaxLedgers = (state: any) => state.taxLedgers;


export const selectTaxLedgersCurrentItem = createSelector([selectTaxLedgers], (taxLedgers) => taxLedgers.current);

export const selectTaxLedgersListItems = createSelector([selectTaxLedgers], (taxLedgers) => taxLedgers.list);

export const selectTaxLedgersItemById = (itemId: any) =>
    createSelector(selectTaxLedgersListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectTaxLedgersCreatedItem = createSelector([selectTaxLedgers], (taxLedgers) => taxLedgers.create);

export const selectTaxLedgersUpdatedItem = createSelector([selectTaxLedgers], (taxLedgers) => taxLedgers.update);

export const selectTaxLedgersReadItem = createSelector([selectTaxLedgers], (taxLedgers) => taxLedgers.read);

export const selectTaxLedgersDeletedItem = createSelector([selectTaxLedgers], (taxLedgers) => taxLedgers.delete);

export const selectTaxLedgersSearchedItems = createSelector([selectTaxLedgers], (taxLedgers) => taxLedgers.search);

export const selectTaxLedgersItemsCount = createSelector([selectTaxLedgers], (taxLedgers) => taxLedgers.count);

export const selectTaxLedgersItemsFilter = createSelector([selectTaxLedgers], (taxLedgers) => taxLedgers.filter);